<template>
  <div class="user-site-search">
    <b-input-group>
      <b-input-group-prepend is-text>
        <feather-icon
          icon="SearchIcon"
          size="16"
          class="text-muted"
        />
      </b-input-group-prepend>

      <b-form-input
        v-if="!dataLoad && viewSearchInput"
        v-model="localSearchQuery"
        class="search-input"
        placeholder="Search by name, email, phone..."
        @keyup.enter="searchTable"
      />

      <b-input-group-append class="append-actions">
        <b-button
          variant="primary"
          class="search-btn"
          @click="searchTable"
        >
          <feather-icon
            icon="SearchIcon"
            size="16"
            class="mr-25"
          />
          Search
        </b-button>

        <b-button
          v-if="localSearchQuery"
          variant="flat-secondary"
          class="clear-btn"
          @click="clearSearch"
        >
          <feather-icon
            icon="XIcon"
            size="16"
          />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: 'SearchInputActionUserSite',
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    viewSearchInput: {
      type: Boolean,
      default: () => false,
    },
    getAllData: {
      type: Function,
      default: () => () => {},
    },
  },
  data() {
    return {
      localSearchQuery: this.$route.query.search || '',
    }
  },
  mounted() {
    this.getRouting()
    window.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    onKeydown(e) {
      if (e.key === 'Escape' && this.localSearchQuery) {
        this.clearSearch()
      }
    },
    clearSearch() {
      this.localSearchQuery = ''
      this.searchTable()
    },
    getRouting() {
      if (this.$route.query.search) {
        this.localSearchQuery = this.$route.query.search
        this.searchTable()
      }
    },
    searchTable() {
      const value = String(this.localSearchQuery || '').trim()

      if (value === '') {
        const updatedQuery = { ...this.$route.query }
        delete updatedQuery.search

        if (JSON.stringify(updatedQuery) !== JSON.stringify(this.$route.query)) {
          this.$router.push({ query: updatedQuery })
        }
        this.getAllData(1)
        return
      }

      if (this.$route.query.search !== value) {
        this.$router.push({
          query: { ...this.$route.query, search: value },
        })
        this.getAllData(1)
      }
    },
  },
}
</script>

<style scoped>
.user-site-search :deep(.input-group-text) {
  border-radius: 12px 0 0 12px;
  border-color: rgba(34, 41, 47, 0.12);
  background: rgba(115, 103, 240, 0.06);
}

.search-input {
  border-color: rgba(34, 41, 47, 0.12);
  border-left: none;
  border-radius: 0;
  height: 42px;
}

.append-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
}

.search-btn {
  height: 42px;
  border-radius: 12px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  font-weight: 900;
  border: none;
  background: linear-gradient(135deg, #7367f0, #00cfe8);
  box-shadow: 0 12px 24px rgba(115, 103, 240, 0.18);
}

.search-btn:hover {
  background: linear-gradient(135deg, rgba(115, 103, 240, 0.95), rgba(0, 207, 232, 0.9));
  box-shadow: 0 14px 28px rgba(115, 103, 240, 0.22);
  transform: translateY(-1px);
}

.search-btn:active {
  transform: translateY(0);
  box-shadow: 0 10px 20px rgba(115, 103, 240, 0.16);
}

.clear-btn {
  border-radius: 12px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
